import { Button, Card, Container, Row } from "react-bootstrap";
import "./Blog.css"

export default function Blog() {
  return (
    <div className="blog mt-5 mb-4" id="blog">
      <Container>
        <Row>
          <div className="col-md-12 col-12 col-sm-12 pt-4 mb-5  text-center heading">
            <h6>
              <span>Blogs</span>
            </h6>
          </div>
          <div className="col-md-12 col-12 col-sm-12">
            <Row className="align-items-center justify-content-between">
            <Card data-aos="fade-up" className="mb-5 mt-5 blogCard" style={{ width: "22rem", height: "500px", backgroundColor: "#1d293a" }}>
                <Card.Img variant="top" src="https://miro.medium.com/max/6000/0*x7f0R1N4Q6PSwlZZ" />
                <Card.Body>
                  <Card.Title>React Fundamentals.</Card.Title>
                  <Card.Text>
                  React is a famous JavaScript library. As a beginner, you may question what we will build by react. Basically, react is a declarative...
                  </Card.Text>
                  <a target="_blank" rel="noreferrer" href="https://medium.com/swlh/react-fundamentals-673722a18bf8">
                    <Button>Read more</Button>
                  </a>
                </Card.Body>
              </Card>

            <Card data-aos="fade-up" className="mb-5 mt-5 blogCard" style={{ width: "22rem", height: "500px", backgroundColor: "#1d293a" }}>
                <Card.Img variant="top" src="https://miro.medium.com/max/6016/0*lg41YPvE73VRdt9c" />
                <Card.Body>
                  <Card.Title>What the heck is the Primitive and Non-Primitive data type???</Card.Title>
                  <Card.Text>
                  As a beginner, we all struggle to understand the data type in JavaScript. But it actually really easy to understand. JavaScript largely...
                  </Card.Text>
                  <a target="_blank" rel="noreferrer" href="https://iamshakibb.medium.com/what-the-heck-is-the-primitive-and-non-primitive-data-type-d6fffc3328c4">
                    <Button>Read more</Button>
                  </a>
                </Card.Body>
              </Card>

              
              
              <Card data-aos="fade-up" className="mb-5 mt-5 blogCard" style={{ width: "22rem", height: "500px", backgroundColor: "#1d293a" }}>
                <Card.Img variant="top" src="https://miro.medium.com/max/5719/0*5cC00qccWA0wWeX8" />
                <Card.Body>
                  <Card.Title>The intermediate concept in Javascript.</Card.Title>
                  <Card.Text>
                  We all love javascript, and we love to do things by using javascript. Today we will learn some intermediate concepts...
                  </Card.Text>
                  <a target="_blank" rel="noreferrer" href="https://iamshakibb.medium.com/the-intermediate-concept-in-javascript-8a7daeb414f0">
                    <Button>Read more</Button>
                  </a>
                </Card.Body>
              </Card>
              

              <Card data-aos="fade-up" className="mb-5 mt-5 blogCard" style={{ width: "22rem", height: "500px", backgroundColor: "#1d293a" }}>
                <Card.Img variant="top" src="https://miro.medium.com/max/6016/0*GG5uVcj67VYk_IR6" />
                <Card.Body>
                  <Card.Title>Var, Let and Const. Which one we should use.</Card.Title>
                  <Card.Text>
                    I start learning JavaScript 3 months ago. As a beginner, I face a lot of questions. One of them is Why should I use Let or Const instead of var. I watch many...
                  </Card.Text>
                  <a target="_blank" rel="noreferrer" href="https://medium.com/@iamshakibb/var-let-and-const-which-one-we-should-use-24feed8e3fac">
                    <Button>Read more</Button>
                  </a>
                </Card.Body>
              </Card>
            </Row>
          </div>
        </Row>
      </Container>
    </div>
  );
}
